import { render } from "./Tenant_Biodata.vue?vue&type=template&id=c5270282"
import script from "./Tenant_Biodata.vue?vue&type=script&lang=js"
export * from "./Tenant_Biodata.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__